import { Rnd } from 'react-rnd';
import {debounce} from 'lodash';
import React, { useEffect, useState, useRef } from "react";
import { useMeasure } from 'react-use';
import PDFViewer from './PDFViewer';
import TotalList from './TotalList';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';


export default function Block2(props) {
    const { parent, id, order, type, retract, title, content, 
      maxWidth, startingHeight, height, 
      columnStart, columnEnd, onHeightChange, 
      onWidthChange, onRearrange, createLocator, 
      endLocator, onDelete, onEdit, overallStartingHeights,
      opacity, setOpacity, isEditing, total, pageAuthor, 
      currentUser, pageSkin, searchTerm, isSearch, groupHeight, groupTitleHeight, isSkinViewer } = props;

    const [blockInnerRef, {width: innerWidth, height: innerHeight}] = useMeasure();
    const [contentRef, {height: contentHeight}] = useMeasure();
    const [titleRef, {height: titleHeight}] = useMeasure();
    const dragStateRef = useRef({
      dragRaf: null,
      prevColumnStart: null,
      prevColumnEnd: null,
      prevY: null,
    });
    const [transitionEnabled, setTransitionEnabled] = useState(true);
    const [doRender, setDoRender] = useState(true)
    const [retracted, setRetracted] = useState(false)
    const [confirmingClose, setConfirmingClose] = useState(false);

  useEffect(() => { //retracting
    if (retract === "autoretract") {
      setRetracted(true);
    } else {
      setRetracted(false);
    }
  }, [retract]);

  function handleRetractClick() {
    setRetracted((prev) => {return !prev})
  }

    const columnWidth = maxWidth / 12;
    const blockWidth = (columnEnd - columnStart) * columnWidth;
    const blockX = columnStart * columnWidth - 14;

    function handleDeleteClick() {
      onDelete(id, order);
    }  

    function handleEditClick() {
      if (isSkinViewer) return;
      onEdit(id, order)
    }

    const handleOnHeightChange = debounce ((order, calculatedHeight) => {
      onHeightChange(order, calculatedHeight);
    }, 100, {leading: true, trailing: false});

    useEffect(() => { //height stuff
      if (innerHeight + 10 + groupTitleHeight > groupHeight || (innerHeight + 10 !== height && (blockWidth - innerWidth > -40 || blockWidth - innerWidth < 40))) {
        if (innerHeight >= contentHeight + titleHeight) {
          handleOnHeightChange(order, innerHeight + 10);
        } else {
          handleOnHeightChange(order, contentHeight + titleHeight);
        }
      }
    }, [ blockWidth, height, contentHeight, titleHeight, innerHeight, innerWidth, order, handleOnHeightChange, groupHeight, groupTitleHeight]);
    
    const handleResizeStart = (e, direction) => {
      if (direction === "left") {
        setTransitionEnabled(false);
      }
      setTimeout(() => {
        setDoRender(false);
      },50)
    };

    const handleResizeStop = (e, direction, ref, delta, position) => {
      setTimeout(() => {
        setDoRender(true);
      },50)
      if(direction === "right") {
        const newColumnEnd = Math.round((position.x + innerWidth)/columnWidth);
        if (newColumnEnd !== columnEnd) {
          if (newColumnEnd > 12) {
            return;
          }
          onWidthChange(id, order, columnStart, newColumnEnd, innerHeight + 10);
        }
      } else if(direction === "left") {
        let newColumnStart = Math.round(position.x/columnWidth);
        if (newColumnStart === -0) {newColumnStart = 0;}
        if (newColumnStart !== columnStart) {
          if (newColumnStart < 0) {
            return;
          }
          onWidthChange(id, order, newColumnStart, columnEnd, innerHeight + 10);
        }
        setTransitionEnabled(true);
      }
    }

    const handleDragStart = () => {
      setTransitionEnabled(false);
    }

    const handleDrag = (e, data) => {
      if (dragStateRef.current.dragRaf) return;

      dragStateRef.current.dragRaf = requestAnimationFrame(() => {
        dragStateRef.current.dragRaf = null;

        const newColumnStart = Math.round(data.x / columnWidth);
        const newColumnEnd = Math.round((data.x + innerWidth) / columnWidth);
        const newY = data.y;

        // Skip if no meaningful change
        if (
          newColumnStart === dragStateRef.current.prevColumnStart &&
          newColumnEnd === dragStateRef.current.prevColumnEnd &&
          Math.abs(newY - dragStateRef.current.prevY) < 2
        ) return;


        let closestHeight = dragStateRef.current.prevClosest;
        let minDist = Infinity;

        for (let i = newColumnStart; i < newColumnEnd; i++) {
          for (let l = 0; l < overallStartingHeights[i].length; l++) {
            const h = overallStartingHeights[i][l];
            const dist =
              newY <= startingHeight
                ? Math.abs(h - newY)
                : Math.abs(h - (newY + height));
            if (dist < minDist) {
              minDist = dist;
              closestHeight = h;
            }
          }
        }

        // Only update locator if it actually changed
        if (closestHeight !== dragStateRef.current.prevClosest || dragStateRef.current.prevColumnStart !== newColumnStart || dragStateRef.current.prevColumnEnd !== newColumnEnd) {
          dragStateRef.current.prevClosest = closestHeight;
        dragStateRef.current.prevColumnStart = newColumnStart;
        dragStateRef.current.prevColumnEnd = newColumnEnd;
        dragStateRef.current.prevY = newY;
          if (closestHeight !== null) {
            createLocator(closestHeight + groupTitleHeight, data.x + 21, innerWidth);
          }
        }
      });
    };

    const handleDragStop = (e, data) => {
      endLocator();
      const newColumnEnd = Math.round((data.x + innerWidth)/columnWidth);
      let newColumnStart = Math.round(data.x/columnWidth);
      if (newColumnStart === -0) {newColumnStart = 0;}
      const pSH = [];
      for (let i = newColumnStart; i < newColumnEnd; i++) {
        for (let l = 0; l < overallStartingHeights[i].length; l++) {
          pSH.push(overallStartingHeights[i][l])
        }
      } 
      if (data.y <= startingHeight) {
        var closestHeight = pSH.reduce((a, b) => {
          return Math.abs(b - data.y) < Math.abs(a - data.y) ? b : a;
        });
      } if (data.y > startingHeight) {
        closestHeight = pSH.reduce((a, b) => {
          return Math.abs(b - (data.y + height)) < Math.abs(a - (data.y + height)) ? b : a;
        });
      }
      const tolerance = 1; // px
      var desiredOrder = overallStartingHeights[12].findIndex((blockItem) => Math.abs(blockItem.SH - closestHeight) <= tolerance && (newColumnStart < blockItem.CE));
      if (desiredOrder === -1) {
        desiredOrder = overallStartingHeights[12].findIndex((blockItem) => ((closestHeight < blockItem.SH)));
      }
      if (desiredOrder > order) {
        desiredOrder --;
      }
      if ((desiredOrder !== order) || (columnStart !== newColumnStart)) {
        if (newColumnStart < 0 || newColumnEnd > 12) {
          return;
        }
        setOpacity(0);

        onRearrange(id, order, desiredOrder, height, newColumnStart, newColumnEnd);  
        setTimeout(() => {
          setOpacity(1)
          setTransitionEnabled(true)
        }, 150)
      }
    }

    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function highlightText(text, phrase) {
      if (!phrase) return text;
      const regex = new RegExp(`(${escapeRegExp(phrase)})`, 'gi');
      return text.replace(regex, '<mark>$1</mark>');
    }

    function highlightHTMLContent(content, phrase) {
      if (!phrase) return content;
      const regex = new RegExp(`(?<!<[^>]*)(${escapeRegExp(phrase)})(?![^<]*>)`, 'gi');
      return content.replace(regex, '<mark>$1</mark>');
    }

    return(
    <div>
      {isSearch && (
        <style>
          {`
            .group-${id} .block-content p a {
              color: ${pageSkin?.linkColor};
            }
            .group-${id} .block-content p a:hover {
              color: ${pageSkin?.linkHoverColor};
            }
            .group-${id} .block-content p,
            .group-${id} .block-content li {
              font-family: ${pageSkin?.textFont}, Times New Roman;
              font-size: ${pageSkin?.textSize}px;
              color: ${pageSkin?.textColor};
            }
          `}
        </style>
      )}
      {confirmingClose && !isSkinViewer &&
      <div id="close-confirm">
        <h2>are you sure you want to delete this?</h2>
        <div>
          <button className="block-type-option" onClick={() => {
            setConfirmingClose(false)
            handleDeleteClick()
            }}>
            OK
          </button>
          <button className="block-type-option" onClick={() => setConfirmingClose(false)}>Cancel</button>
        </div>
      </div>}
        <Rnd
        disableDragging={!isEditing || window.innerWidth < 600}
        className="block"
        bounds={"#group" + parent}
        dragGrid={[columnWidth, 20]}
        resizeGrid={[columnWidth, 1]}
        position={{ x: blockX, y: startingHeight }}
        size={{ width: blockWidth, height }}
        minWidth={columnWidth * 2}
        maxWidth={maxWidth}
        minHeight={40}
        onResizeStart={handleResizeStart}
        onResizeStop={handleResizeStop}
        onDragStart={handleDragStart}
        onDrag={handleDrag}
        onDragStop={handleDragStop}
        style={{
          transition: transitionEnabled ? "all 0.1s ease-in-out" : "none",
          opacity: opacity
        }}
        enableResizing={{
          top: false,
          right: isEditing && window.innerWidth >= 600,
          bottom: false,
          left: isEditing && window.innerWidth >= 600,
          topRight: false,
          bottomRight: false,
          bottomLeft: false,
          topLeft: false,
        }}
      >
        <div className="block-inner" ref={blockInnerRef}>
          <div
            className="border-block"
            style={{
              ...((isEditing && !isSkinViewer) || pageSkin?.blockBorders === 1
                ? { border: `1px solid ${pageSkin?.borderColor}` }
                : {}),
              ...(isSearch && pageSkin?.curvedBorders === 1
                ? { borderRadius: "10px" }
                : {}),
              ...(isSearch
                ? { backgroundColor: pageSkin?.blockBackgroundColor }
                : {})
            }}
          />
          <div className="block-title-container" ref={titleRef}>
            {(isEditing || title.length > 0 || retract !== "unretractable") && <div className="block-title">
              <div className="block-title-border-block" style={{top: `${titleHeight}px`, ...(isSearch? {borderBottom: `1px solid ${pageSkin?.titleBorderColor}`}:{})}}></div>
               <h5 dangerouslySetInnerHTML={{__html: highlightText(title, searchTerm),}}
                style={{fontSize: `${pageSkin?.textSize + 2}px`,
                    fontFamily: `${pageSkin?.textFont}, Times New Roman`,
                    color: pageSkin?.textColor}}
               />
              {(isEditing || retract !== "unretractable") && <div className="block-buttons">
                {retract !== "unretractable" && <div className="retract-div" onClick={handleRetractClick}>{retracted? <ExpandMoreIcon /> : <ExpandLessIcon />}</div>}
                {isEditing && !isSkinViewer &&
                <div className="block-edit-buttons">
                  <button onClick={handleEditClick}><EditIcon /></button>
                  <button onClick={() => {setConfirmingClose(true)}}><DeleteIcon /></button>
                </div>}
              </div>}
            </div>}
          </div>
          <div id="stuff" className={`search-group group-${id}`} ref={contentRef}>
            {!retracted && (
              <>
                {type === "text" && (
                  <div className="block-content" 
                    dangerouslySetInnerHTML={{ __html: highlightHTMLContent(content, searchTerm) }} 
                    style={(!isEditing && title.length === 0 && retract === "unretractable")? 
                      {position: `relative`, top: `7px`, left: `-8px`} : {position: `static`}}></div>
                )}
                {type === "video" && doRender && (
                  <div className="block-content">
                    <iframe
                      width={blockWidth - 20}
                      height={(blockWidth - 20) / 16 * 9}
                      // style={(!isEditing && title.length === 0 && retract === "unretractable")? {position: `relative`, top: `7px`, left: `-8px`} : {position: `static`}}
                      style={{position: `relative`, top: `7px`, left: `-8px`}}
                      src={content}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                )}
                {type === "image" && content && (
                  <div className="block-content">
                    <img src={content} alt="Uploaded content" style={{ width: `${blockWidth - 20}px`, height: `auto`, position: `relative`, top: `4px`, left: `-8px` }} />
                  </div>
                )}
                {type === "pdf" && content && (
                  <PDFViewer content={content} blockWidth={blockWidth}/>
                )}
                {type === "audio" && content && doRender && (
                  <audio controls style={{ position: `relative`, left: `20px` }}>
                    <source src={content} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                )}
                {type === "folders" && total && (
                  <div style={total.length === 0? {paddingLeft: '10px', overflow: `hidden`} : {paddingLeft: '10px', overflow: `hidden`}}>
                    {total.length > 0 ? <TotalList total={total} pageAuthor={pageAuthor} currentUser={currentUser} /> : <p>This user has no pages, no collections, and no folders. They need to go and make some in the Folder Manager.</p>}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Rnd>
    </div>)
}